export default __webpack_public_path__ + "static/media/award.a5b790c0.svg";